import { css } from '@emotion/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import { black, primaryBlue, primaryRed } from '@/styles/utilities/colors';

const NavLinkContainer = css`
  margin: 0.4rem 0;
`;

const NavLink = css`
  display: block;
  padding: 0.8rem 1.6rem;
  border-left: 5px solid transparent;
  line-height: 1.75;

  &.selected {
    border-left: 5px solid ${primaryRed};
    color: ${black};
  }

  &:focus,
  &:hover {
    color: ${primaryBlue};
    span {
      border-bottom: 2px solid ${primaryBlue};
    }
  }
`;

const NavTitle = css`
  text-transform: capitalize;
  font-weight: 800;
  font-size: 1.6rem;
`;

function SideNavItem({ path, title }) {
  const router = useRouter();

  const isSelected = path === router.route;
  return (
    <li css={NavLinkContainer}>
      <Link href={path} passHref>
        <a css={NavLink} data-testid={path} className={isSelected ? 'selected' : ''}>
          <span css={NavTitle}>{title}</span>
        </a>
      </Link>
    </li>
  );
}

export default SideNavItem;
